import React from 'react';
import { useNavigate } from 'react-router-dom';
import SubHeader from '../../../fragments/SubHeader';
import BreadCrumbContainer from '../../../fragments/BreadCrumbContainer';
import BreadCrumb from '../../../fragments/BreadCrumb';
import AddButton from '../../../fragments/Buttons/AddButton';

const SubHeaderFormador = () => {
  const navigate = useNavigate();
  return (
    <div className='flex align-middle justify-between items-center bg-white'>
      <SubHeader>
        <BreadCrumbContainer>
          <BreadCrumb route={'Inicio /'} onClick={() => navigate(`/home/`)} />
          <BreadCrumb route={'Herramientas Nimbus GED /'} onClick={() => navigate(-1)} />
          <BreadCrumb route={'Autores'} active />
        </BreadCrumbContainer>
      </SubHeader>
      <div className='py-5 px-10'>
        <AddButton
          text='Agregar autor'
          onClick={() => navigate('/herramientas/autores/agregarAutor')}
        />
      </div>
    </div>
  );
};

export default SubHeaderFormador;
